const styles = {
  container: '',

  button:
    'gap-x-2 !bg-transparent !text-[#E84F31] !  !p-0 hover:underline !text-sm',
  icon: 'text-sm',
};

export default styles;
